import { CHANGES_MADE, RESET_CHANGES } from './types';

const initialState = false;

export default (
  state: boolean = initialState,
  action: {
    type: string;
  }
): boolean => {
  if (action.type === CHANGES_MADE) {
    return true;
  }

  if (action.type === RESET_CHANGES) {
    return false;
  }

  return state;
};
